const de = {
    ABOVE_SESSIONS_REMAIN: 'die obigen Sitzungen werden jedoch erhalten bleiben.',
    ACTIVE: 'Active',
    ACTIVE_PARTICIPANTS: 'AKTIVE TEILNEHMER',
    ADDITIONAL: 'zusätzliche',
    ADDITIONAL_EXERCISES: 'ZUSÄTZLICHE ÜBUNGEN',
    ADDITIONAL_NOTES: 'Zusätzliche Notizen',
    ADDITIONAL_NOTES_ABOUT_APPEARANCE: 'Zusätzliche Notizen über das Erscheinungsbild',
    ADDITIONAL_NOTES_ABOUT_ATTENDANCE: 'Zusätzliche Notizen über die Teilnahmebereitschaft',
    ADD_OTHER: 'WEITERE HINZUFÜGEN',
    ALREADY_SCHEDULED: 'die Sie entfernen,',
    AND: 'und',
    ANGRY: 'Gestresst',
    ARCHIVE: 'Archive',
    ARCHIVED_PARTICIPANTS: 'Archived Participants',
    ASSIGNED_EDUCATIONAL_MATERIAL: 'Assigned educational material',
    ASSIGNED_EXERCISES: 'ZUGEWIESENE ÜBUNGEN',
    ASSIGNED_PROGRAM: 'Zugewiesenes Programm',
    ATTENDANCE: 'Teilnahmebereitschaft',
    AUDIO_FILE: 'Audiodatei',
    AVAILABILITY: 'VERFÜGBARKEIT',
    AVAILABILITY_WILL_CHANGE_BUT: 'Wenn Sie den Vorgang fortsetzen, wird Ihre Verfügbarkeit für neue Sitzungen aktualisiert,',
    BACK_TO_LOGIN: 'ZURÜCK ZUR ANMELDUNG',
    BEHAVIOUR: 'VERHALTEN',
    BIO_INVALID: 'Der eingegebene Text enthält ungültige Zeichen. Erlaubt sind die Zeichen A-Z, 0-9, &amp; - _ . + ! * \' ( ) ,',
    BODY_SENS: 'Body sens',
    CALIBRATION: 'Kalibrierungsstand',
    CALM: 'Zufrieden',
    CANCELED: 'ABGESAGT',
    CANCEL_CHANGES: 'ÄNDERUNGEN VERWERFEN',
    CBT_MATERIAL: 'KVT-Ressourcen',
    CHANGE: 'wechseln',
    CHANGE_YOUR_PASSWORD: 'Ändern Sie Ihr Passwort',
    CLEAR_ALL: 'ALLES LÖSCHEN',
    COGNITIVE_DISTORTIONS: 'Cognitive Distortions',
    COMPLETED: 'Abgeschlossen',
    COMPLETE_FIELDS_TO_CONTINUE: 'Füllen Sie das Anwesenheitsfeld aus, um fortzufahren',
    COMPLETED_LOWER: 'abgeschlossen',
    COMPLETE_EMAIL_TO_SEND_RESET_LINK: 'Geben Sie Ihre E-Mail-Adresse ein, um Ihren Link zum Zurücksetzen des Passworts zu erhalten.',
    CONTACT: 'KONTAKT',
    CURRENT_SESSION: 'AKTUELLE SITZUNG',
    DATE: 'DATUM',
    DAY: 'TAG',
    DELAYED: 'VERSPÄTET',
    DEMOGRAPHICS: 'ANGABEN ZUR PERSON',
    DEPLOYMENT: 'Deployment',
    DESCRIPTION: 'Beschreibung',
    DESCRIPTION_REQUIRED: 'Eine Beschreibung ist erforderlich',
    DIDNTSHOW: 'NICHT ERSCHIENEN',
    DID_THE_PARTICIPANT_ATTEND_SESSION: 'Hat der Teilnehmer an dieser Sitzung teilgenommen?',
    EDUCATION: 'Ausbildung',
    EDUCATION_INVALID: 'Der eingegebene Text enthält ungültige Zeichen. Erlaubt sind die Zeichen A-Z, 0-9, &amp; - _ . + ! * \' ( ) ,',
    EDUCATIONAL_MATERIAL: 'Educational Material',
    ELEMENT: 'element',
    ELEMENTS: 'elements',
    EMAIL: 'E-Mail',
    EMAIL_ADDRESS: 'E-Mail-Adresse',
    EMAIL_REQUIRED: 'Eine E-Mail ist erforderlich.',
    EMOTION: 'EMOTION',
    ENDS: 'enden am',
    END_TIME_CANNOT_BE_BEFORE_START_TIME: 'Die Endzeit muss nach der Startzeit liegen.',
    ENTER_SESSION: 'Sitzung öffnen',
    ERROR: 'Erforderliches Feld',
    EVALUATION: 'Evaluation',
    EVENT: 'EREIGNIS',
    EXERCISE: 'Übung',
    EXERCISES: 'ÜBUNGEN',
    EXERCISES_LOWER: 'Übungen',
    EXERCISES_COMPLETE: '{0} {1} {2} {3} diese Woche',
    EXERCISES_COMPLETE_2: '{0} {1} diese Woche',
    FAILED_TO_CHANGE_PASSWORD: 'Ihr Passwort konnte nicht geändert werden.',
    FAILED_TO_LOG_IN: 'Ungültige E-Mail oder ungültiges Passwort',
    FAILED_TO_SAVE_CHANGES: 'Ihre Änderungen konnten nicht gespeichert werden.',
    FAILED_TO_UPLOAD_PICTURE: 'Ihr Bild konnte nicht hochgeladen werden.',
    FEEL_DATA_REPORTS: 'feel data reports',
    FEEL_DATA_REPORT_NOT_YET: "The selected participant does not have Feel Data Reports yet.",
    FEEL_DATA_REPORT_NOT_EIGIBLE: "Feel Data Report is not part of this program.",
    FEEL_DATA_REPORT_ERROR: "Unable to retrieve Feel Data Reports.",
    FIRST_NAME: 'Vorname',
    FORGOT_PASSWORD: 'Haben Sie Ihr Passwort vergessen?',
    FOR_NEXT_SESSION: 'FÜR DIE NÄCHSTE SITZUNG',
    FRIDAY: 'Freitag',
    FRIDAYS: 'Freitags',
    FULL_NAME: 'Name',
    HAPPY: 'Fröhlich',
    HELP: 'Hilfe',
    HELPSCOUT: 'Helpscout',
    HOME: 'Startseite',
    HOUR: 'UHRZEIT',
    HOURS_WEARING_TIME:  '{0} hours total wearing time of sensor this week',
    HOW_DID_THE_PARTICIPANT_LOOK: 'Wie sah der Teilnehmer aus?',
    HOW_EMOTIONALLY_AWARE_IS_THE_PARTICIPANT: 'Wie emotional bewusst ist der Teilnehmer?',
    HOW_WOULD_YOU_RATE_PARTICIPANT_COOPERATION: 'Wie würden Sie die Kooperationsbereitschaft des Teilnehmers und die Erfüllung der Programmvorgaben seinerseits bewerten?',
    HOW_WOULD_YOU_RATE_PARTICIPANT_EMOTIONAL_STATE: 'Wie würden Sie die allgemeine emotionale Befindlichkeit des Teilnehmers bewerten?',
    INTENSITY_RATING: 'INTENSITÄTSBEWERTUNG',
    IN_SOME_SLOTS_TO_BE_REMOVED: 'haben Sie Sitzungen geplant.',
    IS_PSYCHIATRIST_REFERRAL_NECESSARY: 'Ist eine Überweisung an einen Psychiater erforderlich?',
    JOURNAL: 'Tagebucheintrag',
    JOURNALS: 'TAGEBUCHEINTRÄGE',
    JOURNALS_COMPLETE: '{0} hat diese Woche Tagebucheinträge {1}',
    KEEP_HERE_EXTRA_NOTES: 'Tragen Sie hier zusätzliche Notizen ein...',
    KEEP_HERE_REMINDERS: 'Tragen Sie hier Erinnerungen für die nächste Sitzung ein…',
    LAST_NAME: 'Name',
    LAST_SESSION: 'Letzte Sitzung',
    LOGOUT_CONFIRMATION_TEXT: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
    LOGGED_TIME: 'Protokollierte Zeit',
    LOG_IN: 'Anmeldung',
    LOG_OUT: 'Abmeldung',
    MINUTES_TIME_IN_APP:  '{0} minutes total time in app this week',
    MONDAY: 'Montag',
    MONDAYS: 'Montags',
    MOOD_BOOSTERS: 'Mood Boosters',
    MOOD_JOURNALS: 'Einträge in das Stimmungstagebuch',
    MORE_WEEK: 'weitere Woche',
    MORE_WEEKS: 'weitere Wochen',
    NAME: 'ΝΑΜΕ',
    NAME_INVALID: 'Ungültiges Format des Vornamens',
    NEW_PASSWORD: 'Neues Passwort',
    NEW_PASSWORD_NEEDS_TO_BE_RETYPED: 'Das neue Passwort muss erneut eingegeben werden.',
    NEW_PASSWORD_NOT_VALID: 'Das Passwort muss aus mindestens 8 Zeichen bestehen und mindestens 3 der folgenden Zeichenarten enthalten: Kleinbuchstaben, Großbuchstaben, Ziffern, Sonderzeichen.',
    NEW_PASSWORD_REQUIRED: 'Ein neues Passwort ist erforderlich.',
    NEXT_EXERCISES: 'NÄCHSTE ÜBUNGEN',
    NEXT_SESSION: 'Nächste Sitzung',
    NO: 'NEIN',
    NOTE: 'Notiz',
    NOT_COMPLETED: 'Not completed',
    NOT_REGISTERED_SC: 'Dieser Teilnehmer ist noch nicht für KVT-Ressourcen angemeldet.',
    NOT_STARTED: 'nicht gestartet',
    NO_PROGRESS: 'Nicht abgeschlossen',
    OF: 'vor',
    OK: 'OK',
    OLD_PASSWORD: 'Altes Passwort',
    OLD_PASSWORD_REQUIRED: 'Ein altes Passwort ist erforderlich.',
    OLD_PASSWORD_WRONG: 'Das eingegebene alte Passwort ist nicht richtig.',
    ONTIME: 'PÜNKTLICH',
    OPEN: 'Öffnen',
    OUT_OF: 'von',
    PAGE_NOT_FOUND: 'What you want is not here',
    PAGE_TITLE: 'Feel',
    PARTICIPANT_ID: 'TEILNEHMER-ID',
    PARTICIPANT: 'Teilnehmer',
    PASSWORD: 'Passwort',
    PASSWORDS_NOT_MATCH: 'Die Passwörter stimmen nicht überein.',
    PASSWORD_DO_NOT_MATCH: 'Das Passwort stimmt nicht überein.',
    PASSWORD_REQUIRED: 'Ein Passwort ist erforderlich.',
    PASTE_LINK_PLACEHOLDER: 'Paste the exercise\'s link..',
    PERFORMANCE: 'LEISTUNG',
    PHONE: 'Telefonnummer',
    PHONE_NUMBER: 'Phone Number',
    PHONE_INVALID: 'Ungültige Telefonnummer',
    PHONE_REQUIRED: 'Eine Telefonnummer ist erforderlich.',
    PHYSICAL_SENSATIONS: 'PHYSISCHE EMPFINDUNGEN',
    PREVIOUS_EXERCISES: 'VORHERIGE ÜBUNGEN',
    PRIVACY_NOTICE: 'Datenschutzrichtlinie',
    PROCEED_WITH_THE_CHANGES: 'Sind Sie sicher, dass Sie diese Änderungen vornehmen möchten?',
    PROGRAM_TYPE: 'Program type',
    PUBLISHED: 'erstellt',
    REFERRAL: 'Referred - previous PID',
    REMINDER: 'Erinnerung',
    RESET_HERE: 'Setzen Sie es hier zurück.',
    RETYPE_NEW_PASSWORD: 'Wiederholen Sie Ihr neues Passwort',
    SAD: 'Traurig',
    SATURDAY: 'Samstag',
    SATURDAYS: 'Samstags',
    SAVE: 'SPEICHERN',
    SAVE_CHANGES: 'ÄNDERUNGEN SPEICHERN',
    SEE_ALL: 'ALLE ANZEIGEN',
    SELECT_VALUE: 'Wert auswählen',
    SEND: 'SENDEN',
    SENSOR_TIME_IN_APP: 'Time in app',
    SENSOR_WEARING_TIME: 'Sensor wearing time',
    SESSION: 'Sitzung',
    SESSIONS: 'Sitzungen',
    SESSION_NOTES: 'Sitzungsnotizen',
    SET_AVAILABILITY: 'VERFÜGBARKEIT FESTLEGEN',
    SET_GOAL: 'ZIELSETZUNG',
    SHOWING: 'Showing',
    SLOTS_CANNOT_OVERLAP: 'DIE ZEITFENSTER IHRER VERFÜGBARKEIT DÜRFEN SICH NICHT ÜBERSCHNEIDEN.',
    SOMETHING_ABOUT_YOU: 'Angaben über Sie',
    STATUS: 'STAND',
    SUNDAY: 'Sonntag',
    SUNDAYS: 'Sonntags',
    SURNAME_INVALID: 'Ungültiges Format des Namens',
    TARGET_COMPLETED: 'Αbgeschlossen',
    THIS_WEEK: 'diese Woche',
    THOUGHTS: 'GEDANKEN',
    THURSDAY: 'Donnerstag',
    THURSDAYS: 'Donnerstags',
    TIME: 'UHRZEIT',
    TIMEZONE: 'Zeitzone',
    TITLE: 'Titel',
    TITLE_REQUIRED: 'Ein Titel ist erforderlich',
    TO: 'BIS',
    TODAY: 'HEUTE',
    TODAY_SESSIONS: 'SITZUNGEN HEUTE',
    TRIGGER_EVENT: 'AUSLÖSENDES EREIGNIS',
    TRIGGER: 'AUSLÖSEN',
    TUESDAY: 'Dienstag',
    TUESDAYS: 'Dienstags',
    UNSET_DIAGNOSIS: 'LÖSCHEN',
    UPCOMING_SESSION: 'Bevorstehende Sitzung',
    URL_ADDRESS: 'URL Address',
    WARNING: 'Warnung',
    WEDNESDAY: 'Mittwoch',
    WEDNESDAYS: 'Mittwochs',
    WEEK: 'Woche',
    WE_HAVE_SENT_YOU_A_PASSWORD_RESET_EMAIL: 'Wir haben Ihnen eine E-Mail zum Zurücksetzen Ihres Passworts gesendet.',
    WHAT_IS_THE_PROGRESS_TOWARDS_THE_SET_GOAL: 'Welcher Fortschritt in Richtung des gesetzten Ziels wurde erreicht?',
    WILL_CONTINUE: 'werden jedoch wie geplant erhalten bleiben.',
    WRITE_DESIRED_GOAL: 'Das Ziel, an das wir uns während des Programms heranarbeiten werden...',
    WRITE_HERE_THE_EXERCISE_DESCRIPTION: 'Geben Sie eine Beschreibung der Übung ein…',
    WRITE_HERE_THE_EXERCISE_TITLE: 'Geben Sie den Übungstitel ein…',
    WRISTBAND: 'Armband',
    YES: 'JA',
    YOUR_CHANGES_HAVE_BEEN_SAVED: 'Ihre Änderungen wurden gespeichert.',
    YOUR_CHANGES_HAVE_BEEN_SAVED_BUT_SESSIONS_WITH: 'Ihre Änderungen wurden gespeichert, Sitzungen mit',
    YOUR_WORDS: 'WORTLAUT DES TEILNEHMERS',
    YOU_HAVE_SESSIONS: 'In manchen der Zeitfenster,'
}
export default de



// WEBPACK FOOTER //
// ./src/languages/de.js